// services/ingredientService.js

import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

const ingredientService = {
  getIngredients: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/api/ingredients`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
  createIngredient: async (ingredient) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${API_URL}/api/ingredients`, ingredient, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
  updateIngredient: async (id, ingredient) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${API_URL}/api/ingredients/${id}`, ingredient, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  deleteIngredient: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${API_URL}/api/ingredients/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
  getPrices: async (ingredientId) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/api/ingredients/${ingredientId}/prices`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
  addPrice: async (ingredientId, { pricePerKg, effectiveDate, note, supplierId }) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${API_URL}/api/ingredients/${ingredientId}/prices`,
      { pricePerKg, effectiveDate, note, supplierId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  getCurrentPrices: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/api/ingredients/prices/current`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data; // [{ ingredientId, pricePerKg }]
  },

  // Approved suppliers (who you can buy it through — plural). Distinct from manufacturerId
  // (who truly makes it, edited directly on the Ingredient).
  getApprovedSuppliers: async (ingredientId) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/api/ingredients/${ingredientId}/suppliers`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
  addApprovedSupplier: async (ingredientId, payload) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${API_URL}/api/ingredients/${ingredientId}/suppliers`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
  updateApprovedSupplier: async (ingredientId, linkId, payload) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${API_URL}/api/ingredients/${ingredientId}/suppliers/${linkId}`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
  removeApprovedSupplier: async (ingredientId, linkId) => {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${API_URL}/api/ingredients/${ingredientId}/suppliers/${linkId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
};


export default ingredientService;

   